// Common error messages for API clients (Inhouse, Transfer, Rooming) and other common messages for components.

export const apiErrorMessages = {
  endpointNotFound: 'No end-point found.',
  badRequest: 'The request sent is invalid. Please verify the data and try again.',
  forbidden: 'You do not have permissions to create a request. Please contact service desk to be added to the proper group.',
  unauthorized: 'An error has occurred identifying current user please reload the page',
  connectionError: 'Connection could not be established. Please check your network connection and try again. If you are in acceptance, make sure you are connected to the VPN.',
}

export const filterTexts = {
  noSearchResultsMessage: 'No items matching your search criteria.',
  filterPublicationCodesPlaceholder: 'All brands / publications',
  filterFlightsPlaceholder: 'All flights',
  filterAccommodationsPlaceholder: 'All accommodations',
  brandUnknown: 'Unknown brand',
  publicationUnknown: 'Unknown publication',
  supplierUnknown: 'Unknown supplier',
}

export const errorPageTexts = {
  title: 'An unexpected error occurred',
  message: 'Something went wrong. Please reload this page to see if this helps, go back to the previous page or try again later.',
  contactSupportMessage: 'If you keep getting this error please contact Team Isla Tortuga.',
  refreshButtonLabel: 'Reload',
}

export const forbiddenPageTexts = {
  message: 'You do not have permission to access this page.',
}
